<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="ct" id="toc_marker-7"><a href="#/Ruddy_Gore2#Contents-A">Author Note</a></p>
<p class="fp">Please note that all Chinese names in this book are derived from the sixteenth-century classic Outlaws of the Marsh. The 1928 cast of Ruddigore did not include any murderers. No identification with any persons alive or dead is intended or should be inferred.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Ruddy_Gore-6.vue?071bbe59